export default "__VITE_ASSET__6f3bab8c__"